import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReactGA from "react-ga";

import SessionTokenContext from "./SessionTokenContext";
import ListingDetails from "./ListingDetails";
import Search from "./Search";
import { Listing, Location, ProviderSearchProps } from "./types";
import { getSessionToken } from "../../lib/global";

function ProviderSearch({ gaTrackingId }: ProviderSearchProps) {
  const [listings, setListings] = useState<Array<Listing>>([]);
  const [location, setLocation] = useState<Location>();
  const sessionToken = getSessionToken();

  ReactGA.initialize(gaTrackingId);

  return (
    <SessionTokenContext.Provider value={sessionToken}>
      <div>
        <BrowserRouter basename="/provider_search">
          <Routes>
            <Route
              path="/"
              element={
                <SessionTokenContext.Consumer>
                  {(token) => {
                    ReactGA.pageview("/provider_search");
                    return (
                      <Search
                        sessionToken={token}
                        updateListings={(listings: Array<Listing>) =>
                          setListings(listings)
                        }
                        updateLocation={(location: Location) =>
                          setLocation(location)
                        }
                        location={location}
                        listings={listings}
                      />
                    );
                  }}
                </SessionTokenContext.Consumer>
              }
            />
            <Route
              path="/:id"
              element={<ListingDetails listings={listings} />}
            />
          </Routes>
        </BrowserRouter>
      </div>
    </SessionTokenContext.Provider>
  );
}

export default ProviderSearch;
